import { Modal, notification } from "antd"
import { CashboxCategoryForm } from "../CashboxCategoryForm"
import { CashboxCategory } from "src/common/models/cashboxCategory"
import { useDispatch, useSelector } from "react-redux"
import { upsertCashboxCategoryApi } from "../state/action"
import { useEffect } from "react"
import { RootState } from "src/state/reducer"
import { SystemDescriptions } from "src/common/descriptions"

interface Props {
    open: boolean
    onAccept: VoidFunction
    onCancel: VoidFunction
}

interface ReduxProps {
    upsertCategorySuccess: boolean
}

export const CreateCashboxCategory = (props: Props) => {
    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        upsertCategorySuccess: state.cashbox.upsertCashboxCategorySuccess,
    }))

    const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CREATE_CASHBOX_CATEGORY

    const openNotification = (message: string, description: string) => {
        notification.success({
            message,
            description,
        });
    };

    useEffect(() => {
        if (reduxProps.upsertCategorySuccess) {

            openNotification(
                descriptions.SUCCESS_MODAL.TITLE,
                descriptions.SUCCESS_MODAL.DESCRIPTION
            )

            props.onAccept()
        }
    }, [reduxProps.upsertCategorySuccess])

    const onFinish = (cashboxCategory: CashboxCategory) => {
        dispatch(upsertCashboxCategoryApi(cashboxCategory))
    }

    return (
        <Modal
            title={descriptions.TITLE}
            centered
            open={props.open}
            width={1000}
            onOk={props.onAccept}
            okText={descriptions.SAVE_BUTTON}
            cancelText={descriptions.CANCEL_BUTTON}
            footer={<></>}
            closable={false}
            zIndex={1000}
            getContainer={false}
            onCancel={props.onCancel}
        >
            <CashboxCategoryForm
                onFinish={onFinish}
                onCancel={props.onCancel}
            />
        </Modal>
    )
}
